import React from 'react'
import classNames from "classnames";

import PropTypes from "prop-types";

import Button from "components/CustomButtons/Button.jsx";
import LayerConfigPanel from "components/Map/controls/LayerConfigPanel.jsx";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Divider from "@material-ui/core/Divider";
import Popper from "@material-ui/core/Popper";
import Icon from "@material-ui/core/Icon";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { withNamespaces } from "react-i18next";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

import { checkTrans } from "helpers";

class LayerSelector extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      openLayers: false,
      openSettings: false,
    };

    this.handleClickLayers = this.handleClickLayers.bind(this);
    this.handleCloseLayers = this.handleCloseLayers.bind(this);

    this.handleClickSettings = this.handleClickSettings.bind(this);
    this.handleCloseSettings = this.handleCloseSettings.bind(this);

    this.handleSelect = this.handleSelect.bind(this);

    this.handleSetOpacity = this.handleSetOpacity.bind(this);
    this.handleSetYear = this.handleSetYear.bind(this);
  };

  handleClickLayers = () => {
    this.setState(state => ({
      openLayers: !state.openLayers,
      openSettings: false
    }));
  };

  handleClickSettings = () => {
    this.setState(state => ({
      openLayers: false,
      openSettings: !state.openSettings
    }));
  };

  handleCloseLayers = event => {
    if (this.anchorLayersEl.contains(event.target)) {
      return;
    }
    this.setState({ openLayers: false });
  };

  handleCloseSettings = event => {
    if (this.anchorSettingsEl.contains(event.target)) {
      return;
    }
    this.setState({ openSettings: false });
  };

  handleSelect(param) {
    this.setState({
      openLayers: false,
    });

    if (param && param.dataCodeGroup) {
      checkTrans(param.dataCodeGroup);
    }

    if (this.props && this.props.onSelect) { //callback
      this.props.onSelect(param);
    }
  };

  handleSetOpacity(value) {
    if (this.props && this.props.onSetOpacity) { //callback
      this.props.onSetOpacity(value / 100);
    }
  };

  handleSetYear(value) {
    if (this.props && this.props.onSetYear && this.props.layer) {
      let ind = this.props.layer.years.indexOf(value)
      if (this.props.layer.layerNames && ind <= this.props.layer.layerNames.length - 1) {
        let layerName = this.props.layer.layerNames[ind];

        this.props.onSetYear(layerName); //callback
      }
    }
  };

  getYear(value) {
    if (this.props && this.props.layer && this.props.layer.layerNames) {
      let ind = this.props.layer.layerNames.indexOf(value);
      return this.props.layer.years[ind];
    } else {
      return null;
    }
  }

  render() {
    const { openLayers, openSettings, selectedLayer } = this.state;

    const {
      t,
      classes,
      buttonText,
      buttonIcon,
      settingsIcon,
      layersList,
      buttonProps,
      dropup,
      // dropdownHeader,
      caret,
      hoverColor,
      dropPlacement,
      noLiPadding,
      innerDropDown,
      navDropdown
    } = this.props;

    const caretClasses = classNames({
      [classes.caret]: true,
      [classes.caretDropup]: dropup && !openLayers,
      [classes.caretActive]: openLayers && !dropup
    });

    const dropdownItem = classNames({
      [classes.dropdownItem]: true,
      [classes[hoverColor + "Hover"]]: true,
      [classes.noLiPadding]: noLiPadding
    });

    const layersMenu = (
      <MenuList role="menu" className={classes.menuList}>
        {this.props.layer ?
          <MenuItem
            key={"none"}
            onClick={() => this.handleSelect(null)}
            className={dropdownItem}
          >
            <Icon className={classes.dropdownIcons}>block</Icon>
            {t("map:clear-selection")}
          </MenuItem> : null
        }
        {this.props.layer ?
          <Divider
            className={classes.dropdownDividerItem}
          />
          : null
        }

        {layersList.map((prop, key) => {
          if (prop.header) {
            return (
              <MenuItem
                key={key}
                className={classes.dropdownHeader}
                disabled
              >
                {t(prop.displayCode)}
              </MenuItem>
            );
          }
          if (prop.divider) {
            return (
              <Divider
                key={key}
                className={classes.dropdownDividerItem}
              />
            );

          } else if (prop.icon && prop.text) {
            return (
              <MenuItem
                key={key}
                onClick={() => this.handleSelect(prop)}
                className={dropdownItem}
              >
                <Icon>{prop.icon}</Icon>
                {prop.text}
              </MenuItem>
            );

          }

          return (
            <MenuItem
              key={key}
              onClick={() => this.handleSelect(prop)}
              className={dropdownItem}
              title={t(prop.displayCode)}
            >
              <Icon className={classes.dropdownIcons}>{prop.icon ? prop.icon : "layers"}</Icon>
              {t(prop.displayCode)}
            </MenuItem>
          );
        })}
      </MenuList>
    );

    const settingsPanel = (
      <LayerConfigPanel
        years={this.props.layer ? this.props.layer.years : null}
        opacity={this.props.opacity}
        year={this.getYear(this.props.version)}
        onSetOpacity={this.handleSetOpacity}
        onSetYear={this.handleSetYear}
        onToggleLayerInfo={this.props.onToggleLayerInfo}
        onToggleLayerLegend={this.props.onToggleLayerLegend}
      />
    );

    return (
      <div className={innerDropDown ? classes.innerManager : classes.manager}>
        <div role="group" className={classNames(buttonText !== undefined ? "" : classes.target, classes.buttonGroup)}>
          <Button
            aria-label="Layer Selection"
            aria-owns={openLayers ? "menu-list-layers" : null}
            aria-haspopup="true"

            buttonRef={node => {
              this.anchorLayersEl = node;
            }}
            {...buttonProps}
            onClick={this.handleClickLayers}
            className={classNames(classes.firstButton, classes.mainButton)}
            disabled={this.props.disabled}
          >
            {buttonIcon !== undefined ? (
              <this.props.buttonIcon className={classes.buttonIcon} />
            ) : null}
            <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
              {this.props.layer ? t(this.props.layer.displayCode) : this.props.title}
            </div>
            {caret ? <b className={caretClasses} /> : null}
          </Button>

          <Button
            aria-label="Layer Configuration"
            aria-owns={openLayers ? "menu-list-settings" : null}
            aria-haspopup="true"
            fullWidth="false"
            buttonRef={node => {
              this.anchorSettingsEl = node;
            }}
            {...buttonProps}
            className={classNames(classes.lastButton, classes.settingsButton)}
            onClick={this.handleClickSettings}
            disabled={this.props.layer ? false : true}
          >
            &nbsp;
              <Icon className={classes.buttonIcon}>{settingsIcon}</Icon>
          </Button>

        </div>
        <Popper
          open={openLayers}
          anchorEl={this.anchorLayersEl}
          transition
          disablePortal
          placement={dropPlacement}
          className={classNames({
            [classes.popperClose]: !openLayers,
            [classes.pooperResponsive]: true,
            [classes.pooperNav]: openLayers && navDropdown,
            [classes.popperLayerSelector]: true
          })}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              in={openLayers}
              id="menu-list-layers"
              style={
                dropup
                  ? { transformOrigin: "0 100% 0" }
                  : { transformOrigin: "0 0 0" }
              }
            >
              <Paper className={classes.dropdown}>
                {innerDropDown ? (
                  layersMenu
                ) : (
                    <ClickAwayListener onClickAway={this.handleCloseLayers} ref="cacat">
                      {layersMenu}
                    </ClickAwayListener>
                  )}
              </Paper>
            </Grow>
          )}
        </Popper>

        <Popper
          open={openSettings}
          anchorEl={this.anchorSettingsEl}
          transition
          disablePortal
          placement={dropPlacement}
          className={classNames({
            [classes.popperClose]: !openSettings,
            [classes.pooperResponsive]: true,
            [classes.pooperNav]: openSettings && navDropdown
          })}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              in={openSettings}
              id="menu-list-settings"
              style={
                dropup
                  ? { transformOrigin: "0 100% 0" }
                  : { transformOrigin: "0 0 0" }
              }
            >
              <Paper className={classes.dropdown}>
                {innerDropDown ? (
                  settingsPanel
                ) : (
                    <ClickAwayListener onClickAway={this.handleCloseSettings} ref="cacat">
                      {settingsPanel}
                    </ClickAwayListener>
                  )}
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

LayerSelector.defaultProps = {
  caret: true,
  dropup: false,
  hoverColor: "primary",
  buttonProps: {
    round: false,
    block: true,
    color: "primary",
    fullWidth: false
  },
  settingsIcon: "settings"
};

LayerSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  hoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ]),
  buttonText: PropTypes.node,
  buttonIcon: PropTypes.func,
  layersList: PropTypes.array,
  buttonProps: PropTypes.object,
  dropup: PropTypes.bool,
  dropdownHeader: PropTypes.node,
  rtlActive: PropTypes.bool,
  caret: PropTypes.bool,
  dropPlacement: PropTypes.oneOf([
    "bottom",
    "top",
    "right",
    "left",
    "bottom-start",
    "bottom-end",
    "top-start",
    "top-end",
    "right-start",
    "right-end",
    "left-start",
    "left-end"
  ]),
  noLiPadding: PropTypes.bool,
  innerDropDown: PropTypes.bool,
  navDropdown: PropTypes.bool,
  // This is a function that returns the clicked menu item
  onClick: PropTypes.func
};

export default withNamespaces()(withStyles(mapStyle)(LayerSelector));